<template>
  <v-dialog v-model="dialog" persistent :width="options.width">
    <v-card :color="options.color" dark outlined>
      <v-card-text>
        <v-col class="subtitle-1 text-center primary--text">
          {{ message }}
        </v-col>
        <v-col>
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 *
 * Insert component where you want to use it:
 * <loader ref="loader"></loader>
 *
 * Call it:
 * this.$refs.loader.start("msg_to_display");
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$loader
 * <template>
 *   <v-app>
 *     ...
 *     <loader ref="loader"></loader>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$loader = this.$refs.loader;
 * }
 */
export default {
  name: "loader",
  data() {
    return {
      dialog: false,
      message: null,
      options: {
        color: "white",
        width: 350,
      },
    };
  },
  methods: {
    start(msg, options) {
      this.dialog = true;
      this.change(msg);
      this.options = Object.assign(this.options, options);
    },
    change(msg) {
      this.message = msg || "Please stand by, processing your request";
    },
    stop() {
      this.dialog = false;
    },
  },
};
</script>